import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import HelpPanel from '../Help/HelpPanel';

export default function Layout() {
  const [helpOpen, setHelpOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="flex flex-col h-screen bg-dark-900">
      <Header onMenuClick={() => setDrawerOpen(v => !v)} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar drawerOpen={drawerOpen} onDrawerClose={() => setDrawerOpen(false)} />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>

      <button
        onClick={() => setHelpOpen(v => !v)}
        className={`fixed bottom-5 right-5 z-50 w-10 h-10 rounded-full shadow-xl flex items-center justify-center transition-all duration-200 text-sm font-bold ${
          helpOpen ? 'bg-slate-700 text-white' : 'bg-slate-600 hover:bg-slate-500 text-slate-200'
        }`}
        title="Ajuda"
      >
        ?
      </button>

      <HelpPanel open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
}
